/* eslint-disable no-unused-vars */
import types from '../types'
import { nullCheck, refine } from '../../utils/object'
import Vue from 'vue'
import moment from 'moment'
import { length, mass } from '../../utils/unit'
import apiCaller from '../../utils/apiCaller'


const familyMap = new Map()
familyMap.set(1, 'stroke')
familyMap.set(2, 'heart')
familyMap.set(3, 'hprts')
familyMap.set(4, 'diabml')
familyMap.set(5, 'cancer')

const familyKeyMap = new Map()
familyKeyMap.set('', 0)
familyKeyMap.set('stroke', 1)
familyKeyMap.set('heart', 2)
familyKeyMap.set('hprts', 3)
familyKeyMap.set('diabml', 4)
familyKeyMap.set('cancer', 5)

const diseaseMap = new Map()
diseaseMap.set(1, 'stroke')
diseaseMap.set(2, 'heart')
diseaseMap.set(3, 'hprts')
diseaseMap.set(4, 'diabml')
diseaseMap.set(5, 'hplpdm')
diseaseMap.set(6, 'phss')
diseaseMap.set(7, 'dementia')
diseaseMap.set(8, 'liver')
diseaseMap.set(9, 'stomach')
diseaseMap.set(10, 'colorectal')
diseaseMap.set(11, 'prostate')
diseaseMap.set(12, 'breast')
diseaseMap.set(13, 'lung')
diseaseMap.set(14, 'etc')

const diseaseKeyMap = new Map()
diseaseKeyMap.set('', 0)
diseaseKeyMap.set('stroke', 1)
diseaseKeyMap.set('heart', 2)
diseaseKeyMap.set('hprts', 3)
diseaseKeyMap.set('diabml', 4)
diseaseKeyMap.set('hplpdm', 5)
diseaseKeyMap.set('phss', 6)
diseaseKeyMap.set('dementia', 7)
diseaseKeyMap.set('liver', 8)
diseaseKeyMap.set('stomach', 9)
diseaseKeyMap.set('colorectal',10)
diseaseKeyMap.set('prostate', 11)
diseaseKeyMap.set('breast', 11)
diseaseKeyMap.set('lung', 13)
diseaseKeyMap.set('etc', 14)

const state = {
    section1: {
        // Section 1
        name: null,
        birth: null,
        gender: null,
        //  허리둘레
        waist: null,
        waistMode: 0,
        //  키
        height: null,
        heightMode: 0,
        //  몸무게
        weight: null,
        weightMode: 0,
        //  혈압
        minPressure: null,
        maxPressure: null,
        //  BMI
        bmi: null
    },
    section2: {
        //  Section 2
        //  요단백
        proteinuria: null,
        //  혈액
        //  총 콜레스테롤
        cholesterol: null,
        //  중성지방
        triglyceride: null,
        //  HDL
        hdl: null,
        //  LDL
        ldl: null,
        //  AST
        ast: null,
        //  ALT
        alt: null,
        //  감마지티피
        yGTP: null,
        //  혈청크레아티닌
        creatinine: null,
        //  혈색소
        hemoglobin: null,
        //  공복혈당    (fasting blood sugar)
        fbs: null,
    },
    section3: {
        //  Section 3
        disability: null,
        diseaseModel: [],
        //  가족력 (family medical history)
        fmhModel: [],
    },
    section4: {
        //  Section 4
        //  음주량
        drinkModel: null,
        drinkAmount: null,
        //  흡연량
        smokeModel: null,
        smokeAmount: 0,
        smokeTerm: 0,
        //  운동
        workout1: null,
        workout2: null,
        workout3: null
    },
    checkup: { }
}

const mutations = {
    [types.addItem.mutations.section1] (state, { name, birth, gender, waist, waistMode, height, heightMode, weight, weightMode, minPressure, maxPressure, bmi }) {
        state.section1.name = name
        state.section1.gender = gender
        state.section1.birth = birth
        state.section1.waist = waist
        state.section1.waistMode = waistMode
        state.section1.height = height
        state.section1.heightMode = heightMode
        state.section1.weight = weight
        state.section1.weightMode = weightMode
        state.section1.minPressure = minPressure
        state.section1.maxPressure = maxPressure
        state.section1.bmi = bmi
    },
    [types.addItem.mutations.section2] (state, { proteinuria, cholesterol, triglyceride, hdl, ldl, ast, alt, yGTP, creatinine, hemoglobin, fbs }) {
        state.section2.proteinuria = proteinuria
        state.section2.cholesterol = cholesterol
        state.section2.triglyceride = triglyceride
        state.section2.hdl = hdl
        state.section2.ldl = ldl
        state.section2.ast = ast
        state.section2.alt = alt
        state.section2.yGTP = yGTP
        state.section2.creatinine = creatinine
        state.section2.hemoglobin = hemoglobin
        state.section2.fbs = fbs
    },
    [types.addItem.mutations.section3] (state, { disability, diseaseModel, fmhModel }) {
        state.section3.disability = disability

        Vue.set(state.section3, 'diseaseModel', diseaseModel)
        Vue.set(state.section3, 'fmhModel', fmhModel)
    },
    [types.addItem.mutations.clearAll] (state) {
        Vue.set(state, 'section1', { name: null, birth: null, gender: null, waist: null, waistMode: 0, height: null, heightMode: 0, weight: null, weightMode: 0, minPressure: null, maxPressure: null, bmi: null })
        Vue.set(state, 'section2', { proteinuria: null, cholesterol: null, triglyceride: null, hdl: null, ldl: null, ast: null, alt: null, yGTP: null, creatinine: null, hemoglobin: null, fbs: null })
        Vue.set(state, 'section3', { disability: null, diseaseModel: [], fmhModel: [] })
        Vue.set(state, 'section4', { drinkModel: null, drinkAmount: null, smokeModel: null, smokeAmount: 0, smokeTerm: 0, workout1: null, workout2: null, workout3: null })
    },
    [types.addItem.mutations.section4] (state, { drinkModel, drinkAmount, smokeAmount, smokeTerm, smokeModel, workout1, workout2, workout3 }) {
        state.section4.drinkModel = drinkModel
        state.section4.drinkAmount = drinkAmount
        state.section4.smokeModel = smokeModel
        state.section4.smokeAmount = smokeAmount
        state.section4.smokeTerm = smokeTerm
        state.section4.workout1 = workout1
        state.section4.workout2 = workout2
        state.section4.workout3 = workout3
    },
    [types.addItem.mutations.fetchCheckup] (state, { checkupNo, checkup }) {
        checkup = refine(checkup)
        Vue.set(state.checkup, checkupNo, checkup)
    }
}

const actions = {
    [types.addItem.actions.section1] ({ commit }, { name, birth, gender, waist, waistMode, height, heightMode, weight, weightMode, minPressure, maxPressure, bmi }) {
        commit(types.addItem.mutations.section1, { name, birth, gender, waist, waistMode, height, heightMode, weight, weightMode, minPressure, maxPressure, bmi })
    },
    [types.addItem.actions.section2] ({ commit }, { proteinuria, cholesterol, triglyceride, hdl, ldl, ast, alt, yGTP, creatinine, hemoglobin, fbs }) {
        commit(types.addItem.mutations.section2, { proteinuria, cholesterol, triglyceride, hdl, ldl, ast, alt, yGTP, creatinine, hemoglobin, fbs })
    },
    [types.addItem.actions.section3] ({ commit },  { disability, diseaseModel, fmhModel }) {
        commit(types.addItem.mutations.section3,  { disability, diseaseModel, fmhModel })
    },
    [types.addItem.actions.section4] ({ commit }, { drinkModel, drinkAmount, smokeModel, smokeAmount, smokeTerm, workout1, workout2, workout3 }) {
        commit(types.addItem.mutations.section4, { drinkModel, drinkAmount, smokeModel, smokeAmount, smokeTerm, workout1, workout2, workout3 })
    },
    [types.addItem.actions.clearAll] ({ commit }) {
        commit(types.addItem.mutations.clearAll)
    },
    async [types.addItem.actions.submit] ({ state }, { authToken }) {
        const height = new length(state.section1.height, state.section1.heightMode === 0 ? 'cm' : 'in')
        const waist = new length(state.section1.waist, state.section1.waistMode === 0 ? 'cm' : 'in')
        const weight = new mass(state.section1.weight, state.section1.weightMode === 0 ? 'kg' : 'lb')

        const birthday              = `${state.section1.birth}`
        const blds                  = `${state.section2.fbs}`
        const bmi                   = `${state.section1.bmi}`
        const bpHigh                = `${state.section1.maxPressure}`
        const bpLow                 = `${state.section1.minPressure}`
        const checkupDate           = moment().format('YYYYMMDD')
        const creatinine            = `${state.section2.creatinine}`
        const dfabPtnCd             = `${state.section3.disability}`
        const drnkHabit             = `${state.section4.drinkModel}`
        const drnkQty               = `${state.section4.drinkAmount}`
        const fmly                  = state.section3.fmhModel.filter(item => item !== 0).map(item => familyMap.get(item)).join(',')
        const gammaGtp              = `${state.section2.yGTP}`
        const gender                = `${state.section1.gender + 1}`
        const hchk                  = state.section3.diseaseModel.filter(item => item !== 0).map(item => diseaseMap.get(item)).join(',')
        const hdlChole              = `${state.section2.hdl}`
        const heightCm              = `${height.to('cm')}`
        const heightFeet            = `${height.to('feet')}`
        const heightInch            = `${height.to('in')}`
        const heightUnit            = state.section1.heightMode === 0 ? 'cm' : 'inch'
        const hmg                   = `${state.section2.hemoglobin}`
        const ldlChole              = `${state.section2.ldl}`
        const mov20WekFreq          = `${state.section4.workout3}`
        const mov30WekFreq          = `${state.section4.workout2}`
        const name                  = `${state.section1.name}`
        const oligProteCd           = `${state.section2.proteinuria + 1}`
        const sgotAst               = `${state.section2.ast}`
        const sgptAlt               = `${state.section2.alt}`
        const smkQty                = `${state.section4.smokeAmount}`
        const smkStatType           = `${state.section4.smokeModel + 1}`
        const smkTerm               = `${state.section4.smokeTerm}`
        const totChole              = `${state.section2.cholesterol}`
        const triglyceride          = `${state.section2.triglyceride}`
        const waistCm               = `${waist.to('cm')}`
        const waistInch             = `${waist.to('in')}`
        const waistUnit             = state.section1.waistMode === 0 ? 'cm' : 'in'
        const weightKg              = `${weight.to('kg')}`
        const weightLb              = `${weight.to('lb')}`
        const weightUnit            = state.section1.weightMode === 0 ? 'kg' : 'lb'
        const wlk30WekFreq          = `${state.section4.workout1}`

        const res = await apiCaller.checkUp.add({ authToken, birthday, blds, bmi, bpHigh, bpLow, checkupDate, creatinine, dfabPtnCd, drnkHabit, drnkQty, fmly, gammaGtp, gender, hchk, hdlChole, heightCm, heightFeet, heightInch, heightUnit, hmg, ldlChole, mov20WekFreq, mov30WekFreq, name, oligProteCd, sgotAst, sgptAlt, smkQty, smkStatType, totChole, triglyceride, waistCm, waistInch, waistUnit, weightKg, weightLb, weightUnit, wlk30WekFreq, smkTerm })

        if (res.error !== null) {
            return null
        }

        return res.data
    },
    async [types.addItem.actions.modify] ({ }, { authToken, checkupNo }) {
        const height = new length(state.section1.height, state.section1.heightMode === 0 ? 'cm' : 'in')
        const waist = new length(state.section1.waist, state.section1.waistMode === 0 ? 'cm' : 'in')
        const weight = new mass(state.section1.weight, state.section1.weightMode === 0 ? 'kg' : 'lb')

        const birthday              = `${state.section1.birth}`
        const blds                  = `${state.section2.fbs}`
        const bmi                   = `${state.section1.bmi}`
        const bpHigh                = `${state.section1.maxPressure}`
        const bpLow                 = `${state.section1.minPressure}`
        const checkupDate           = moment().format('YYYYMMDD')
        const creatinine            = `${state.section2.creatinine}`
        const dfabPtnCd             = `${state.section3.disability}`
        const drnkHabit             = `${state.section4.drinkModel}`
        const drnkQty               = `${state.section4.drinkAmount}`
        const fmly                  = state.section3.fmhModel.filter(item => item !== 0).map(item => familyMap.get(item)).join(',')
        const gammaGtp              = `${state.section2.yGTP}`
        const gender                = `${state.section1.gender + 1}`
        const hchk                  = state.section3.diseaseModel.filter(item => item !== 0).map(item => diseaseMap.get(item)).join(',')
        const hdlChole              = `${state.section2.hdl}`
        const heightCm              = `${height.to('cm')}`
        const heightFeet            = `${height.to('feet')}`
        const heightInch            = `${height.to('in')}`
        const heightUnit            = state.section1.heightMode === 0 ? 'cm' : 'inch'
        const hmg                   = `${state.section2.hemoglobin}`
        const ldlChole              = `${state.section2.ldl}`
        const mov20WekFreq          = `${state.section4.workout3}`
        const mov30WekFreq          = `${state.section4.workout2}`
        const name                  = `${state.section1.name}`
        const oligProteCd           = `${state.section2.proteinuria + 1}`
        const sgotAst               = `${state.section2.ast}`
        const sgptAlt               = `${state.section2.alt}`
        const smkQty                = `${state.section4.smokeAmount}`
        const smkStatType           = `${state.section4.smokeModel + 1}`
        const smkTerm               = `${state.section4.smokeTerm}`
        const totChole              = `${state.section2.cholesterol}`
        const triglyceride          = `${state.section2.triglyceride}`
        const waistCm               = `${waist.to('cm')}`
        const waistInch             = `${waist.to('in')}`
        const waistUnit             = state.section1.waistMode === 0 ? 'cm' : 'in'
        const weightKg              = `${weight.to('kg')}`
        const weightLb              = `${weight.to('lb')}`
        const weightUnit            = state.section1.weightMode === 0 ? 'kg' : 'lb'
        const wlk30WekFreq          = `${state.section4.workout1}`

        const res = await apiCaller.checkUp.modify({ authToken, checkupNo, birthday, blds, bmi, bpHigh, bpLow, checkupDate, creatinine, dfabPtnCd, drnkHabit, drnkQty, fmly, gammaGtp, gender, hchk, hdlChole, heightCm, heightFeet, heightInch, heightUnit, hmg, ldlChole, mov20WekFreq, mov30WekFreq, name, oligProteCd, sgotAst, sgptAlt, smkQty, smkStatType, totChole, triglyceride, waistCm, waistInch, waistUnit, weightKg, weightLb, weightUnit, wlk30WekFreq, smkTerm })

        if (res.error !== null) {
            return null
        }

        return res.data
    },
    async [types.addItem.actions.fetchList] ({ commit }, { authToken, checkupNo }) {
        const res = await apiCaller.checkUp.get({ authToken, checkupNo })

        if (res.error !== null) {
            return false
        }

        const birth                 = res.data.birthday
        const bmi                   = Number(res.data.blds)
        const maxPressure           = Number(res.data.bpHigh)
        const minPressure           = Number(res.data.bpLow)
        const gender                = Number(res.data.gender) - 1
        const name                  = res.data.name

        const fbs                   = Number(res.data.blds)
        const creatinine            = Number(res.data.creatinine)
        const yGTP                  = Number(res.data.gammaGtp)
        const hdl                   = Number(res.data.hdlChole)
        const hemoglobin            = Number(res.data.hmg)
        const ldl                   = Number(res.data.ldlChole)
        const proteinuria           = Number(res.data.oligProteCd) - 1
        const ast                   = Number(res.data.sgotAst)
        const alt                   = Number(res.data.sgptAlt)
        const cholesterol           = Number(res.data.totChole)
        const triglyceride          = Number(res.data.triglyceride)

        const disability            = Number(res.data.dfabPtnCd)
        const drinkModel            = Number(res.data.drnkHabit)
        const drinkAmount           = Number(res.data.drnkQty)

        const workout1              = Number(res.data.wlk30WekFreq)
        const workout2              = Number(res.data.mov30WekFreq)
        const workout3              = Number(res.data.mov20WekFreq)

        const smokeAmount           = Number(res.data.smkQty)
        const smokeModel            = Number(res.data.smkStatType) - 1
        const smokeTerm             = Number(res.data.smkTerm)

        let height
        let waist
        let weight
        let heightMode
        let waistMode
        let weightMode

        if (res.data.heightUnit === 'cm') {
            height = new length(Number(res.data.heightCm), 'cm').to('cm')
            heightMode = 0
        } else if (res.data.heightUnit === 'in') {
            height = new length(Number(res.data.heightInch), 'in').to('in')
            heightMode = 1
        } else if (res.data.heightUnit === 'feet') {
            height = new length(Number(res.data.heightFeet), 'feet').to('feet')
            heightMode = 2
        }

        if (res.data.weightUnit === 'kg') {
            weight = new mass(Number(res.data.weightKg), 'kg').to('kg')
            weightMode = 0
        } else if (res.data.weightUnit === 'lb') {
            weight = new mass(Number(res.data.weightLb), 'lb').to('lb')
            weightMode = 1
        }

        if (res.data.waistUnit === 'cm') {
            waist = new length(Number(res.data.waistCm), 'cm').to('cm')
            waistMode = 0
        } else if (res.data.waistUnit === 'in') {
            waist = new length(Number(res.data.waistInch), 'in').to('in')
            waistMode = 1
        } else if (res.data.waistUnit === 'feet') {
            //  이 경우는 없겠지?
        }

        const fmhModel              = res.data.fmly.split(',').map(item => familyKeyMap.get(item))
        const diseaseModel          = res.data.hchk.split(',').map(item => diseaseKeyMap.get(item))

        commit(types.addItem.mutations.section1, { name, birth, gender, waist, waistMode, height, heightMode, weight, weightMode, minPressure, maxPressure, bmi })
        commit(types.addItem.mutations.section2, { proteinuria, cholesterol, triglyceride, hdl, ldl, ast, alt, yGTP, creatinine, hemoglobin, fbs })
        commit(types.addItem.mutations.section3, { diseaseModel, fmhModel, disability })
        commit(types.addItem.mutations.section4, { drinkModel, drinkAmount, smokeModel, smokeAmount, smokeTerm, workout1, workout2, workout3 })

        return true
    },
    async [types.addItem.actions.fetchCheckup] ({ commit }, { authToken, checkupNo }) {
        const res = await apiCaller.checkUp.get({ authToken, checkupNo })
        if (res.error === null) {
            const checkup = res.data
            commit(types.addItem.mutations.fetchCheckup, { checkupNo, checkup })
            return true
        }
        return false
    }
}

const getters = {
    [types.addItem.getters.section1]: state => state.section1,
    [types.addItem.getters.checkSection1]: state => nullCheck(state.section1),
    [types.addItem.getters.section2]: state => state.section2,
    [types.addItem.getters.checkSection2]: state => nullCheck(state.section2),
    [types.addItem.getters.section3]: state => state.section3,
    [types.addItem.getters.checkSection3]: state => nullCheck(state.section3),
    [types.addItem.getters.section4]: state => state.section4,
    [types.addItem.getters.checkSection4]: state => nullCheck(state.section4),
    [types.addItem.getters.checkup]: state => checkupNo => state.checkup[checkupNo] || null
}

export default {
    state,
    mutations,
    actions,
    getters
}
